import { FC } from 'react';

import { Box } from '@mui/material';

interface FlagProps {
  color: string;
  children: JSX.Element;
}

const Flag: FC<FlagProps> = ({ color, children }) => {
  return (
    <Box position="relative">
      <Box pt={1} position="absolute" width="100%" height="100%" display="flex" justifyContent="center" color="white">
        {children}
      </Box>
      <svg width={30} height={38} viewBox="0 0 30 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0H30V38L15 30L0 38V0Z" fill={color} />
      </svg>
    </Box>
  );
};

export default Flag;
